export const SEARCH_DATA = [
  ["firstName", "First Name"],
  ["lastName", "Last Name"],
  ["email", "Email Address"],
];
